<template>
    <section class="home home--overview" ref="overviewSection" v-if="overview.length > 0">
        <HelpersSpotlightFade v-if="windowWidth >= 1280" />
        <div class="home__bg" v-html="overview[0].body"></div>
    </section>
</template>

<script setup>
import { ref, onMounted } from 'vue';

import { usePostServiceStore } from '@/stores/postService'

const postStore = usePostServiceStore();
const { fetchHomeOverviewData } = usePostServiceStore();

await fetchHomeOverviewData();

const { overview } = storeToRefs(postStore);

const overviewSection = ref(null);

onMounted(() => {
    // ฟังก์ชันสำหรับกำหนด threshold ตามขนาดหน้าจอ
    const getThresholdByScreenSize = () => {
        if (window.innerWidth <= 576) {          
            return 0.5;
        } else if (window.innerWidth <= 768) {   
            return 0.8;
        } else if (window.innerWidth <= 1024) {   
            return 0.6;
        } else {                                
            return 0.7;
        }
    };

    // สร้าง observer ด้วย threshold ที่เหมาะสม

    const createObserver = () => {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // เพิ่ม class animate-active เมื่อซีนปรากฏครั้งแรก
                        if (!entry.target.classList.contains('animate-active')) {
                            entry.target.classList.add('animate-active');
                        }
                        entry.target.classList.add('is-visible');
                    } else {
                        // ไม่ลบ class animate-active แต่ลบ class is-visible
                        entry.target.classList.remove('is-visible');
                    }
                });
            }, {
                threshold: getThresholdByScreenSize(),
                rootMargin: '0px'
            });

            if (overviewSection.value) {
                observer.observe(overviewSection.value);
            }

            return observer;
    };

    // สร้าง observer ครั้งแรก
    let observer = createObserver();

    // เพิ่ม event listener สำหรับ resize
    const handleResize = () => {
        // ยกเลิก observer เดิม
        if (overviewSection.value) {
            observer.unobserve(overviewSection.value);
        }
        // สร้าง observer ใหม่ด้วย threshold ที่เหมาะสม
        observer = createObserver();
    };

    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => {
        if (overviewSection.value) {
            observer.unobserve(overviewSection.value);
        }
        window.removeEventListener('resize', handleResize);
    };
});
</script>

<style lang="scss" scoped>
 @import "@/assets/scss/app";
</style>